
import { NavLink } from "react-router-dom";
import { cn } from "@/lib/utils";
import { BarChart3, Crown, Image } from "lucide-react";
import { checkPremiumStatusSync } from "@/App";
import { useLanguage } from "@/contexts/language";
import { t } from "@/utils/translations";

export const navItems = [
  {
    translationKey: 'common.home' as const,
    path: "/",
    premium: false,
    icon: null
  },
  {
    translationKey: 'common.generate' as const,
    path: "/generate",
    premium: false,
    icon: null
  },
  {
    translationKey: 'common.entries' as const,
    path: "/entries",
    premium: false,
    icon: null
  },
  {
    translationKey: 'common.statistics' as const,
    path: "/statistics",
    premium: false,
    icon: <BarChart3 className="h-3.5 w-3.5 mr-1 inline-block" />
  },
  {
    translationKey: 'common.gallery' as const,
    path: "/gallery",
    premium: true,
    icon: <Image className="h-3.5 w-3.5 mr-1" />
  },
  {
    translationKey: 'common.premium' as const,
    path: "/premium",
    premium: true,
    icon: null
  },
];

interface NavItemsProps {
  mobile?: boolean;
}

const NavItems = ({ mobile = false }: NavItemsProps) => {
  const isPremium = checkPremiumStatusSync();
  const { language } = useLanguage();

  return (
    <>
      {navItems.map((item) => {
        return (
          <NavLink
            key={item.path}
            to={item.path}
            className={({ isActive }) => cn(
              "px-3 py-2 rounded-lg text-sm font-medium transition-all duration-200",
              "hover:bg-accent hover:text-accent-foreground",
              isActive 
                ? "bg-accent text-accent-foreground" 
                : "text-foreground/80",
              item.premium && "flex items-center gap-1",
              mobile && "flex items-center gap-2"
            )}
          >
            {item.icon}
            {t(item.translationKey, language)}
            {item.premium && <Crown className="h-3.5 w-3.5 text-amber-500 ml-1" />}
          </NavLink>
        );
      })}
    </>
  );
};

export default NavItems;
